import { memo, useCallback, useState } from "react";

import { Button } from "ui/components/Button/Button";
import { TextField } from "ui/components/TextField/TextField";
import { ContactPhoneSearchFilterProps } from "./types";
import { ContactPhoneSearchFormValues } from "services/api/contacts/types";
import { initialContactPhoneSearchForm } from "services/api/contacts/consts";

const ContactPhoneSearchFilters: React.FC<ContactPhoneSearchFilterProps> = (
  props
) => {
  const { onAddNew, onSearchChange } = props;

  const [formValues, setFormValues] = useState<ContactPhoneSearchFormValues>(
    initialContactPhoneSearchForm
  );

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const updatedFormValues = { ...formValues, search: e.target.value };
    setFormValues(updatedFormValues);
    onSearchChange(updatedFormValues);
  };

  const handleResetFormClick = useCallback(() => {
    const updatedFormValues = { ...formValues, search: "" };
    setFormValues(initialContactPhoneSearchForm);
    onSearchChange(updatedFormValues);
  }, []);

  return (
    <>
      <div className=" ">
        <div className="flex justify-between items-center gap-3">
          <div className="flex">
            <div className="mr-3">
              <TextField
                type="text"
                name="search"
                value={formValues.search}
                onChange={handleSearchChange}
                placeholder="Pretraži"
                startIcon="../media/icons/search.svg"
                cssClassName="bg-white"
              />
            </div>

            <div className="mr-3 flex items-center">
              <span
                onClick={handleResetFormClick}
                className="text-xs font-bold cursor-pointer text-gray-700"
              >
                RESET
              </span>
            </div>
          </div>
          <div className=" py-3 flex justify-end ">
            <Button
              variant="primary"
              children="Dodaj telefon"
              startIcon="/media/icons/plus.svg"
              onClick={onAddNew}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(ContactPhoneSearchFilters);
